/**************************************************************************/
/*** 'Column Selector' implemented By Fahad Akbar(fahadakbar24@gmail.com)**/
/**************************************************************************/

// Import the Column Selector's Controller
import {
  columnSelectorCtrl
} from './controller';

const columnSelector = () => {
  // Directive Definition object for Column Selector
  return {
    restrict: 'AE',
    replace: true,
    scope: {
        columnsList: '=', // list of Colums that are to be selected from
        openColumnsPopup: '=', // The method outside the directive's controller that is responsible
                               // for asking to open the modal
        pageId: "=",
        isColumnSelectionToBeSaved: "=saveSelection"
    },
    template: `
        <script type="text/ng-template" id="columnSelectTemplate.html">
        <div class="modal-header">
          <center>
            <h3>Columns</h3>
            <h5>Select Columns to show</h5>
          </center>
        </div>
        <div class="modal-row">
          <div class="col-md-12 lang-modal" >
              <br>
              <ul class="checkbox-grid pref-language-list clearfix">
                  <li ng-repeat = "column in columnsList" >
                      <label class="ui-checkbox">
                          <input name="column.ref_column.column_label"
                              type="checkbox"
                              ng-model="column.show"
                              ng-checked="column.show"
                           >
                          <span>{{column.ref_column.column_label || column.label}}</span>
                      </label>
                  </li>
              </ul>
              <br>
          </div>
        </div>
        <div class="modal-footer">
          <center>
            <button class="btn btn-gap-v btn-default" ng-click="closeSelectionPopup()">Close</button>
          </center>
        </div>
      </script>
        `,
    controller: columnSelectorCtrl
  }
}

// Define the Column Selector
angular
  .module('app.directives')
  .directive('columnSelector', columnSelector);



// WEBPACK FOOTER //
// ./scripts/shared/directives/column-selector/directive.js